/* TG inline predictive search (desktop >= 990px).
   Shows a full-width results panel under the header for the inline header
   field, using the same predictive-search section markup as the search
   drawer (sections/predictive-search.liquid) plus a SALONS group.
   Does not touch the drawer code: it has its own fetch, cache and keyboard
   handling. Keyboard model: aria-activedescendant (focus stays in the input). */
(function () {
  'use strict';

  var PANEL_ID = 'TgInlineSearchPanel';
  var INPUT_ID = 'tg-search-bar-input-header';
  var DATA_ID = 'tg-search-prompts-data';
  var PREFIX = 'tg-inline-';
  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;
  var CACHE_MAX = 20;
  var DESKTOP_QUERY = '(min-width: 990px)';
  var ID_REF_ATTRS = {
    'for': 1, 'aria-labelledby': 1, 'aria-describedby': 1, 'aria-controls': 1,
    'aria-owns': 1, 'aria-activedescendant': 1, 'form': 1, 'list': 1
  };

  var panel = document.getElementById(PANEL_ID);
  var input = document.getElementById(INPUT_ID);
  if (!panel || !input || panel.getAttribute('data-tg-inline-init') === 'true') { return; }
  panel.setAttribute('data-tg-inline-init', 'true');

  var body = panel.querySelector('[data-tg-inline-body]') || panel;
  var field = input.closest('.tg-search-bar__field');
  var host = input.closest('.header__utils-item--search-inline') || input.parentElement;
  var clearBtn = host.querySelector('[data-tg-inline-clear]');
  var status = host.querySelector('[data-tg-inline-status]');
  var section = input.closest('.section-header') || document.querySelector('.section-header');
  var headerBar = input.closest('#header, .js-header') || (section && section.querySelector('#header, .js-header')) || section;
  var subNav = section ? section.querySelector('.tg-sub-nav') : null;
  var rootEl = document.documentElement;
  var LOCK_CLASS = 'tg-inline-search-open';

  /* Dims the page below the panel, like the drawer's overlay */
  var backdrop = document.createElement('span');  /* span: base.css hides empty divs */
  backdrop.className = 'tg-inline-search-backdrop';
  backdrop.setAttribute('aria-hidden', 'true');
  backdrop.hidden = true;
  panel.parentNode.insertBefore(backdrop, panel);

  var config = readConfig();
  var mq = window.matchMedia ? window.matchMedia(DESKTOP_QUERY) : null;

  var timer = null;
  var controller = null;
  var cache = {};
  var cacheKeys = [];
  var currentQuery = '';
  var items = [];
  var activeIndex = -1;
  var rafId = 0;

  function readConfig() {
    var out = { salonUrl: '/pages/salon-finder', searchUrl: '/search' };
    var el = document.getElementById(DATA_ID);
    if (el) {
      try {
        var parsed = JSON.parse(el.textContent || '{}');
        if (parsed.salonUrl) { out.salonUrl = String(parsed.salonUrl); }
        if (parsed.searchUrl) { out.searchUrl = String(parsed.searchUrl); }
      } catch (e) { /* keep defaults */ }
    }
    return out;
  }

  function isDesktop() { return mq ? mq.matches : window.innerWidth >= 990; }
  function isOpen() { return !panel.hidden; }

  function withQuery(url, q) {
    var hash = '';
    var i = url.indexOf('#');
    if (i !== -1) { hash = url.slice(i); url = url.slice(0, i); }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(q) + hash;
  }

  function buildFetchUrl(q) {
    var base = panel.getAttribute('data-url') || '/search/suggest';
    return base + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search';
  }

  /* The sub-nav row counts as part of the bar only while it is rendered and
     the header paints a fully opaque background behind it (the scrolled
     state). At the top of the page the row is transparent, so the bar ends at
     #header. Mid-transition values are ignored; transitionend re-measures. */
  function subNavInBar() {
    if (!subNav || !section) { return false; }
    var cs = window.getComputedStyle(subNav);
    if (cs.display === 'none' || cs.visibility === 'hidden') { return false; }
    if (!subNav.getBoundingClientRect().height) { return false; }
    var bg = window.getComputedStyle(section).backgroundColor;
    return /^rgb\(/.test(bg) || /,\s*1\)$/.test(bg);
  }

  /* Panel position: flush against the bottom of the visible header bar. */
  function barBottom() {
    var bottom = headerBar ? headerBar.getBoundingClientRect().bottom : 0;
    if (subNavInBar()) {
      /* whole header block, including its bottom border */
      bottom = Math.max(bottom, subNav.getBoundingClientRect().bottom, section.getBoundingClientRect().bottom);
    }
    return Math.max(0, Math.round(bottom));
  }

  function setTop() {
    var value = barBottom() + 'px';
    panel.style.setProperty('--tg-inline-search-top', value);
    backdrop.style.setProperty('--tg-inline-search-top', value);
  }

  function onViewportChange() {
    if (rafId) { return; }
    rafId = window.requestAnimationFrame(function () {
      rafId = 0;
      if (!isDesktop()) { closePanel(); return; }
      if (isOpen()) { setTop(); }
    });
  }

  function closeMegaPanels() {
    var open = document.querySelectorAll('.tg-mega-panel.is-open, .tg-sub-mega-panel.is-open, .tg-sub-dropdown.is-open');
    Array.prototype.forEach.call(open, function (el) { el.classList.remove('is-open'); });
    var active = document.querySelectorAll('.header__nav-link.tg-active');
    Array.prototype.forEach.call(active, function (el) { el.classList.remove('tg-active'); });
    var expanded = document.querySelectorAll('.tg-sub-nav__link[aria-expanded="true"]');
    Array.prototype.forEach.call(expanded, function (el) { el.setAttribute('aria-expanded', 'false'); });
  }

  function syncClear() {
    var has = input.value !== '';
    if (clearBtn) { clearBtn.hidden = !has; }
    if (field) { field.classList.toggle('tg-has-value', has); }
  }

  function setStatus(text) {
    if (status) { status.textContent = text || ''; }
  }

  function setActive(index) {
    if (activeIndex > -1 && items[activeIndex]) {
      items[activeIndex].classList.remove('tg-inline-is-active');
    }
    activeIndex = index;
    if (index > -1 && items[index]) {
      var el = items[index];
      el.classList.add('tg-inline-is-active');
      input.setAttribute('aria-activedescendant', el.id);
      if (el.scrollIntoView) { el.scrollIntoView({ block: 'nearest' }); }
    } else {
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
    }
  }

  function openPanel() {
    panel.hidden = false;
    backdrop.hidden = false;
    rootEl.classList.add(LOCK_CLASS);
    input.setAttribute('aria-expanded', 'true');
    closeMegaPanels();
    setTop();
  }

  function closePanel() {
    clearTimeout(timer);
    if (controller) { controller.abort(); controller = null; }
    if (!isOpen() && activeIndex === -1) { return; }
    setActive(-1);
    panel.hidden = true;
    backdrop.hidden = true;
    rootEl.classList.remove(LOCK_CLASS);
    input.setAttribute('aria-expanded', 'false');
    setStatus('');
  }

  function hasText(a) {
    return (a.textContent || '').trim() !== '' || !!a.getAttribute('aria-label');
  }

  /* One keyboard stop per destination: product cards carry an image link and
     a title link with the same href, so keep the one that has text. */
  function collectItems() {
    var seen = {};
    var order = [];
    var anchors = panel.querySelectorAll('a[href]');
    Array.prototype.forEach.call(anchors, function (a) {
      if (!a.getClientRects().length) { return; }
      var key = a.getAttribute('href');
      var entry = seen[key];
      if (!entry) {
        entry = { a: a };
        seen[key] = entry;
        order.push(entry);
      } else if (!hasText(entry.a) && hasText(a)) {
        entry.a = a;
      }
    });
    items = order.map(function (e, i) {
      e.a.id = PREFIX + 'option-' + i;
      return e.a;
    });
    activeIndex = -1;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) { node.className = className; }
    if (text != null) { node.textContent = text; }
    return node;
  }

  function renameIds(root) {
    var map = {};
    var count = 0;
    Array.prototype.forEach.call(root.querySelectorAll('[id]'), function (node) {
      var old = node.id;
      map[old] = PREFIX + old;
      node.id = map[old];
      count += 1;
    });
    if (!count) { return; }
    Array.prototype.forEach.call(root.querySelectorAll('*'), function (node) {
      Array.prototype.slice.call(node.attributes).forEach(function (attr) {
        if (attr.name === 'id' || !attr.value) { return; }
        var value = attr.value;
        var next = value;
        if (ID_REF_ATTRS[attr.name]) {
          next = value.split(/\s+/).map(function (t) { return map[t] || t; }).join(' ');
        } else if (value.indexOf('#') !== -1) {
          next = value.replace(/#([^\s)"']+)/g, function (m, id) {
            return map[id] ? '#' + map[id] : m;
          });
        }
        if (next !== value) { node.setAttribute(attr.name, next); }
      });
    });
  }

  function viewAllLabel(q) {
    var tpl = panel.getAttribute('data-view-all-label') || 'View results for “__TERMS__”';
    return tpl.replace('__TERMS__', function () { return q; });
  }

  function buildSalonRow(q) {
    var row = el('div', 'predictive-search__row tg-inline-search__salons');
    row.appendChild(el('h6', 'search-drawer__title', 'SALONS'));
    var list = el('ul', 'predictive-search__links list-unstyled');
    var li = el('li', 'predictive-search__links-item');
    var a = el('a', 'predictive-search__links-link tg-inline-search__salon-link',
      'Find a salon in “' + q + '” →');
    a.setAttribute('href', withQuery(config.salonUrl, q));
    li.appendChild(a);
    list.appendChild(li);
    row.appendChild(list);
    return row;
  }

  function buildViewAllCol(q) {
    var col = el('div', 'predictive-search__col');
    var row = el('div', 'predictive-search__row');
    var a = el('a', 'button button--text predictive-search__link');
    a.setAttribute('href', withQuery(config.searchUrl, q));
    a.textContent = viewAllLabel(q);
    row.appendChild(a);
    col.appendChild(row);
    return col;
  }

  /* html: the innerHTML of #shopify-section-predictive-search ('' if none). */
  function render(q, html) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html || '';
    var frag = tpl.content;

    renameIds(frag);

    /* Drawer-only controls */
    Array.prototype.forEach.call(
      frag.querySelectorAll('.js-btn-close-drawer, .drawer__button-close, .js-btn-clear-text'),
      function (n) { n.parentNode.removeChild(n); }
    );

    var results = frag.querySelector('.predictive-search__results');
    if (!results) {
      results = el('div', 'predictive-search__results');
      frag.appendChild(results);
    }

    /* The drawer's "view results" control is a submit button; here it is a link. */
    var oldBtn = results.querySelector('.predictive-search__link');
    var viewCol = oldBtn ? oldBtn.closest('.predictive-search__col') : null;
    if (viewCol) { viewCol.parentNode.removeChild(viewCol); }
    viewCol = buildViewAllCol(q);
    if (oldBtn && (oldBtn.textContent || '').trim()) {
      viewCol.querySelector('.predictive-search__link').textContent = oldBtn.textContent.trim();
    }

    var productCol = results.querySelector('.predictive-search__col-product');
    var leftCol = null;
    Array.prototype.forEach.call(results.children, function (child) {
      if (!leftCol && child.classList.contains('predictive-search__col') &&
          child !== productCol) {
        leftCol = child;
      }
    });
    if (!leftCol) {
      leftCol = el('div', 'predictive-search__col');
      results.insertBefore(leftCol, results.firstChild);
    }
    if (!productCol) {
      productCol = el('div', 'predictive-search__col predictive-search__col-product');
    }
    /* "No results" message sits in the left column under SALONS */
    var message = results.querySelector(':scope > .predictive-search__message');
    if (message) { leftCol.appendChild(message); }

    /* Order: left, products, view-all (the drawer CSS makes the last column full width) */
    results.insertBefore(leftCol, results.firstChild);
    results.insertBefore(productCol, leftCol.nextSibling);
    results.appendChild(viewCol);

    leftCol.insertBefore(buildSalonRow(q), leftCol.firstChild);

    body.textContent = '';
    body.appendChild(frag);

    openPanel();
    collectItems();

    var salonLink = body.querySelector('.tg-inline-search__salon-link');
    var viewLink = body.querySelector('.predictive-search__link');
    var count = items.filter(function (a) { return a !== salonLink && a !== viewLink; }).length;
    setStatus(count ? count + (count === 1 ? ' result' : ' results') : 'No results');

    var quickCart = document.querySelector('quick-cart-drawer');
    if (quickCart && typeof quickCart.initTriggers === 'function') {
      try { quickCart.initTriggers(); } catch (e) { /* not needed for hidden add-to-cart */ }
    }
  }

  function remember(q, html) {
    if (!Object.prototype.hasOwnProperty.call(cache, q)) {
      cacheKeys.push(q);
      if (cacheKeys.length > CACHE_MAX) { delete cache[cacheKeys.shift()]; }
    }
    cache[q] = html;
  }

  function stillCurrent(q) {
    return input.value.trim() === q && isDesktop();
  }

  function run(q) {
    currentQuery = q;
    if (Object.prototype.hasOwnProperty.call(cache, q)) {
      render(q, cache[q]);
      return;
    }
    if (controller) { controller.abort(); }
    controller = window.AbortController ? new AbortController() : null;
    var opts = controller ? { signal: controller.signal } : {};
    var mine = controller;
    fetch(buildFetchUrl(q), opts)
      .then(function (response) {
        if (!response.ok) { throw new Error(String(response.status)); }
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var sec = doc.querySelector('#shopify-section-predictive-search');
        var html = sec ? sec.innerHTML : '';
        remember(q, html);
        if (controller === mine) { controller = null; }
        if (stillCurrent(q)) { render(q, html); }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') { return; }
        if (controller === mine) { controller = null; }
        /* Degrade to SALONS + "View results" only */
        if (stillCurrent(q)) { render(q, ''); }
      });
  }

  function onInput() {
    syncClear();
    if (!isDesktop()) { return; }
    clearTimeout(timer);
    setActive(-1);
    var q = input.value.trim();
    if (q.length < MIN_CHARS) {
      closePanel();
      return;
    }
    timer = setTimeout(function () { run(q); }, DEBOUNCE_MS);
  }

  function move(delta) {
    var total = items.length;
    if (!total) { return; }
    /* Stops: -1 (the input itself), 0..total-1, then back to -1 */
    var next = activeIndex + delta;
    if (next >= total) { next = -1; }
    if (next < -1) { next = total - 1; }
    setActive(next);
  }

  function clearValue(refocus) {
    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    closePanel();
    if (refocus) { input.focus(); }
  }

  function onKeydown(event) {
    if (!isDesktop()) { return; }
    var key = event.key;
    if (key === 'ArrowDown' || key === 'ArrowUp') {
      if (!isOpen()) {
        var q = input.value.trim();
        if (q.length >= MIN_CHARS && Object.prototype.hasOwnProperty.call(cache, q)) {
          event.preventDefault();
          run(q);
        }
        return;
      }
      if (!items.length) { return; }
      event.preventDefault();
      move(key === 'ArrowDown' ? 1 : -1);
    } else if (key === 'Enter') {
      if (isOpen() && activeIndex > -1 && items[activeIndex]) {
        event.preventDefault();
        items[activeIndex].click();
      }
    } else if (key === 'Escape') {
      if (isOpen()) {
        event.preventDefault();
        closePanel();
      } else if (input.value !== '') {
        event.preventDefault();
        clearValue(false);
      }
    } else if (key === 'Tab') {
      closePanel();
    }
  }

  function outside(target) {
    return !panel.contains(target) && !host.contains(target);
  }

  input.addEventListener('input', onInput);
  input.addEventListener('keydown', onKeydown);

  if (clearBtn) {
    clearBtn.addEventListener('click', function () { clearValue(true); });
  }

  /* Keep focus in the input when clicking inside the panel; links still activate. */
  panel.addEventListener('mousedown', function (event) { event.preventDefault(); });

  document.addEventListener('mousedown', function (event) {
    if (isOpen() && outside(event.target)) { closePanel(); }
  }, true);
  document.addEventListener('focusin', function (event) {
    if (isOpen() && outside(event.target)) { closePanel(); }
  });

  backdrop.addEventListener('click', function () { closePanel(); });

  window.addEventListener('resize', onViewportChange);
  window.addEventListener('scroll', onViewportChange, { passive: true });

  /* Header state changes (scrolled class, announcement offset, size) move the bar */
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(onViewportChange);
    if (headerBar) { ro.observe(headerBar); }
    if (section && section !== headerBar) { ro.observe(section); }
  }
  if (section) { section.addEventListener('transitionend', onViewportChange); }
  if (window.MutationObserver) {
    var mo = new MutationObserver(onViewportChange);
    if (section) { mo.observe(section, { attributes: true, attributeFilter: ['class', 'style'] }); }
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  if (mq) {
    if (mq.addEventListener) { mq.addEventListener('change', onViewportChange); }
    else if (mq.addListener) { mq.addListener(onViewportChange); }
  }

  /* Back/forward cache restores the page with the panel in its old state */
  window.addEventListener('pageshow', function () { closePanel(); syncClear(); });
  window.addEventListener('pagehide', function () { rootEl.classList.remove(LOCK_CLASS); });

  syncClear();
})();
